export default {
  boxInfo: { method: 'get', url: '/game-api/box/info' }, // 获取盲盒信息
  boxQuiz: { method: 'post', url: '/game-api/box/quiz' }, // 进行抽奖
  boxQuizLog: { method: 'get', url: '/game-api/box/quizLog' } // 抽奖记录
}

